import { render, staticRenderFns } from "./FilterData.vue?vue&type=template&id=2cc8e224&scoped=true"
import script from "./FilterData.vue?vue&type=script&lang=js"
export * from "./FilterData.vue?vue&type=script&lang=js"
import style0 from "./FilterData.vue?vue&type=style&index=0&id=2cc8e224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8e224",
  null
  
)

export default component.exports